import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { startLogout } from '../../helpers/auth'

const Layout = ({children}) => {
    const dispatch = useDispatch()
    const {displayName, rol, state} = useSelector(state => state.perfil)

    const handleLogout = () => {
        dispatch(startLogout());
    }

    return (
        <div className='container-dashboard'>
            <div className='header'>
                <label htmlFor='bars_ck'>
                    <img 
                        src='https://firebasestorage.googleapis.com/v0/b/centro-madreantonia.appspot.com/o/icons%2Fmenu.svg?alt=media&token=cfca80b0-e4f3-432f-ad95-a306b4d726d4' 
                        alt='menu'
                    />
                </label>
                <span className='txt_name'> {displayName} </span>
                <button className='btn btn_danger' onClick={handleLogout}>Salir</button>
            </div>
            <input type="checkbox" id="bars_ck" className="nav__checkbox"></input>
            <div className='nav__items'>
                <Link to={'/home'} className='nav__link' ><i className='fas fa-home'/> <span>Inicio</span></Link>
                {
                    rol === 'docente'
                    && state
                    &&  
                        <>
                            <Link to={'/perfil'} className='nav__link' ><i className='fas fa-user-circle'/> <span>Perfil</span></Link>
                            <div className='swanky_wrapper'>
                                <input id='Aula' name='radio' type='radio' />
                                <label htmlFor='Aula'>
                                    <span>Aula</span>
                                    <div className='lil_arrow'></div>
                                    <div className='bar'></div>
                                    <div className='swanky_wrapper__content'>
                                        <ul>
                                            <li><Link to={'/asignaturas'}><i className='fas fa-book-reader'/> <span>Asignaturas</span></Link></li>
                                            <li><Link to={'/estadisticas'}><i className='fas fa-chart-line'/> <span>Estadisticas</span></Link></li>
                                        </ul>
                                    </div>
                                </label>
                            </div>

                            <div className='swanky_wrapper'>
                                <input id='Info' name='radio' type='radio' />
                                <label htmlFor='Info'>
                                    <span>Info</span>
                                    <div className='lil_arrow'></div>
                                    <div className='bar'></div>
                                    <div className='swanky_wrapper__content'>
                                        <ul>
                                            <li><Link to={'/flui'}><i className='fas fa-file'/> <span>Flui</span></Link></li>
                                            <li><Link to={'/contribuciones'}><i className='fab fa-buffer'/> <span>Contribuciones</span></Link></li>
                                            <li><Link to={'/creditos'}><i className='fas fa-users'/> <span>Creditos</span></Link></li>
                                        </ul>
                                    </div>
                                </label>
                            </div>
                        </>
                }
                {
                    rol === 'admin'
                    && <Link to={'/docentes'} className='nav__link' >Docentes</Link>
                }
                
            </div>
            <div className='conenedor__dash'>
                <div className='dash__contenido'>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout
